// agents/src/components/NotificationSettings.jsx

import { useState, useEffect } from 'react';
import notificationService from '../services/notificationService';

export default function NotificationSettings({ onClose }) {
  const [status, setStatus] = useState(notificationService.getStatus());
  const [testSent, setTestSent] = useState(false);

  useEffect(() => {
    setStatus(notificationService.getStatus());
  }, []);

  const handleRequestPermission = async () => {
    const granted = await notificationService.requestPermission();
    setStatus(notificationService.getStatus());
    if (granted) {
      alert('Permisos de notificación concedidos ✓');
    } else {
      alert('Permisos de notificación denegados. Por favor, actívalos manualmente en la configuración del navegador.');
    }
  };

  const handleToggleNotifications = () => {
    notificationService.toggle();
    setStatus(notificationService.getStatus());
  };

  const handleToggleSound = () => {
    notificationService.toggleSound();
    setStatus(notificationService.getStatus());
  };

  const handleTestNotification = () => {
    notificationService.show('Notificación de prueba', {
      body: 'Si ves esto, las notificaciones están funcionando correctamente ✓',
      icon: '/logo192.png'
    });
    setTestSent(true);
    setTimeout(() => setTestSent(false), 3000);
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>🔔 Configuración de Notificaciones</h2>
          <button onClick={onClose} style={styles.closeButton}>✕</button>
        </div>

        <div style={styles.content}>
          {/* Estado del navegador */}
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Estado</h3>
            <div style={styles.statusGrid}>
              <div style={styles.statusItem}>
                <span>Soporte del navegador:</span>
                <span style={status.supported ? styles.statusOk : styles.statusError}>
                  {status.supported ? '✓ Soportado' : '✗ No soportado'}
                </span>
              </div>
              <div style={styles.statusItem}>
                <span>Permisos:</span>
                <span style={status.permission === 'granted' ? styles.statusOk : styles.statusWarning}>
                  {status.permission === 'granted' ? '✓ Concedidos' :
                   status.permission === 'denied' ? '✗ Denegados' :
                   '⚠ Pendiente'}
                </span>
              </div>
              <div style={styles.statusItem}>
                <span>Notificaciones:</span>
                <span style={status.enabled ? styles.statusOk : styles.statusWarning}>
                  {status.enabled ? '✓ Habilitadas' : '✗ Deshabilitadas'}
                </span>
              </div>
              <div style={styles.statusItem}>
                <span>Sonido:</span>
                <span style={status.soundEnabled ? styles.statusOk : styles.statusWarning}>
                  {status.soundEnabled ? '✓ Habilitado' : '✗ Deshabilitado'}
                </span>
              </div>
            </div>
          </div>

          {/* Solicitar permisos */}
          {status.permission !== 'granted' && (
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Permisos</h3>
              <p style={styles.description}>
                Para recibir notificaciones desktop, necesitas conceder permisos al navegador.
              </p>
              <button onClick={handleRequestPermission} style={styles.primaryButton}>
                Solicitar Permisos
              </button>
            </div>
          )}

          {/* Configuración */}
          {status.permission === 'granted' && (
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Configuración</h3>

              <div style={styles.option}>
                <div>
                  <strong>Notificaciones Desktop</strong>
                  <p style={styles.optionDescription}>
                    Recibe alertas cuando lleguen nuevos mensajes o se requiera tu atención
                  </p>
                </div>
                <label style={styles.switch}>
                  <input
                    type="checkbox"
                    checked={status.enabled}
                    onChange={handleToggleNotifications}
                  />
                  <span style={styles.slider}></span>
                </label>
              </div>

              <div style={styles.option}>
                <div>
                  <strong>Sonido de Notificación</strong>
                  <p style={styles.optionDescription}>
                    Reproduce un sonido cuando llegue una notificación
                  </p>
                </div>
                <label style={styles.switch}>
                  <input
                    type="checkbox"
                    checked={status.soundEnabled}
                    onChange={handleToggleSound}
                  />
                  <span style={styles.slider}></span>
                </label>
              </div>
            </div>
          )}

          {/* Prueba */}
          {status.permission === 'granted' && status.enabled && (
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Prueba</h3>
              <p style={styles.description}>
                Envía una notificación de prueba para verificar que todo funciona correctamente
              </p>
              <button
                onClick={handleTestNotification}
                style={styles.secondaryButton}
                disabled={testSent}
              >
                {testSent ? '✓ Enviada' : 'Enviar Notificación de Prueba'}
              </button>
            </div>
          )}

          {/* Ayuda */}
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Tipos de Notificaciones</h3>
            <ul style={styles.list}>
              <li><strong>Nuevo mensaje:</strong> Cuando un cliente envía un mensaje</li>
              <li><strong>Sin respuesta:</strong> Cuando una conversación lleva tiempo sin responder</li>
              <li><strong>Agente requerido:</strong> Cuando se necesita atención manual</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem',
    borderBottom: '1px solid #e8e8e8'
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    color: '#333'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#999',
    padding: '0.5rem',
    lineHeight: 1
  },
  content: {
    padding: '1.5rem'
  },
  section: {
    marginBottom: '2rem'
  },
  sectionTitle: {
    fontSize: '1.1rem',
    marginBottom: '1rem',
    color: '#333'
  },
  description: {
    color: '#666',
    fontSize: '0.9rem',
    marginBottom: '1rem'
  },
  statusGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '1rem'
  },
  statusItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.75rem',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px'
  },
  statusOk: {
    color: '#52c41a',
    fontWeight: 'bold'
  },
  statusWarning: {
    color: '#faad14',
    fontWeight: 'bold'
  },
  statusError: {
    color: '#f5222d',
    fontWeight: 'bold'
  },
  option: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
    backgroundColor: '#f9f9f9',
    borderRadius: '4px',
    marginBottom: '1rem'
  },
  optionDescription: {
    fontSize: '0.85rem',
    color: '#666',
    margin: '0.25rem 0 0 0'
  },
  switch: {
    position: 'relative',
    display: 'inline-block',
    width: '50px',
    height: '24px'
  },
  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#ccc',
    transition: '0.4s',
    borderRadius: '24px'
  },
  primaryButton: {
    backgroundColor: '#423ef4',
    color: '#fff',
    border: 'none',
    padding: '0.75rem 1.5rem',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  secondaryButton: {
    backgroundColor: '#52c41a',
    color: '#fff',
    border: 'none',
    padding: '0.75rem 1.5rem',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem'
  },
  list: {
    margin: 0,
    paddingLeft: '1.5rem',
    color: '#666'
  }
};
